
import React from "react";

const AuthDivider = () => {
  return (
    <div className="flex items-center w-full my-4">
      <div className="flex-grow border-t border-gray-300"></div>
      <span className="px-4 text-gray-500 text-sm">OR</span>
      <div className="flex-grow border-t border-gray-300"></div>
    </div>
  );
};

export default AuthDivider;
